import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import "./SelfDrive.css";

// HERO BG
import bg from "../../Assets/carimgpor.png";

// ALL 40 CAR IMAGES
import c1 from "../../Assets/SelfDrive/Tharr.jpg";
import c2 from "../../Assets/SelfDrive/Fortuner.jpg";
import c3 from "../../Assets/SelfDrive/Scorpio N.jpg";
import c4 from "../../Assets/SelfDrive/Safari.jpg";
import c5 from "../../Assets/SelfDrive/xuv700.jpg";
import c6 from "../../Assets/SelfDrive/Innova Crysta.jpg";
import c7 from "../../Assets/SelfDrive/Kia Seltos.jpg";
import c8 from "../../Assets/SelfDrive/Hyundai Creta.jpg";
import c9 from "../../Assets/SelfDrive/MG Hector.jpg";
import c10 from "../../Assets/SelfDrive/Toyota Hyryder.jpg";
import c11 from "../../Assets/SelfDrive/Ertiga CNG 2025.jpg";
import c12 from "../../Assets/SelfDrive/Verna Sunroof.jpg";
import c13 from "../../Assets/SelfDrive/Baleno 2025.jpg";
import c14 from "../../Assets/SelfDrive/Swift 2025.jpg";
import c15 from "../../Assets/SelfDrive/Honda City.jpg";
import c16 from "../../Assets/SelfDrive/i20 Sportz.jpg";
import c17 from "../../Assets/SelfDrive/Amaze.jpg";
import c18 from "../../Assets/SelfDrive/Dzire.jpg";
import c19 from "../../Assets/SelfDrive/Altroz.jpg";
import c20 from "../../Assets/SelfDrive/Ciaz.jpg";
import c21 from "../../Assets/SelfDrive/Audi A6.jpg";
import c22 from "../../Assets/SelfDrive/BMW 5 Series.jpg";
import c23 from "../../Assets/SelfDrive/Mercedes C-Class.jpg";
import c24 from "../../Assets/SelfDrive/Jaguar XF.jpg";
import c25 from "../../Assets/SelfDrive/Audi Q7.jpg";
import c26 from "../../Assets/SelfDrive/BMW X5.jpg";
import c27 from "../../Assets/SelfDrive/Mercedes E-Class.jpg";
import c28 from "../../Assets/SelfDrive/BMW 7 Series.jpg";
import c29 from "../../Assets/SelfDrive/Audi A4.jpg";
import c30 from "../../Assets/SelfDrive/Volvo XC90.jpg";
import c31 from "../../Assets/SelfDrive/Luxury Wedding Car.jpg";
import c32 from "../../Assets/SelfDrive/Bride & Groom Special.jpg";
import c33 from "../../Assets/SelfDrive/Full Day Wedding Package.jpg";
import c34 from "../../Assets/SelfDrive/VIP Event Car.jpg";
import c35 from "../../Assets/SelfDrive/Luxury Decorated Car.jpg";
import c36 from "../../Assets/SelfDrive/Barat Car Package.png";
import c37 from "../../Assets/SelfDrive/Wedding SUV Package.jpg";
import c38 from "../../Assets/SelfDrive/Luxury Convoy.jpg";
import c39 from "../../Assets/SelfDrive/Reception Entry Car.jpg";
import c40 from "../../Assets/SelfDrive/Corporate Event Package.jpg";

const PHONE = "9755357721";

const ALL_CARS = [
  { name: "Mahindra Thar 2025", img: c1, price12: 3000, price24: 4500, category: "SUV" },
  { name: "Toyota Fortuner", img: c2, price12: 8000, price24: 11000, category: "SUV" },
  { name: "Scorpio N", img: c3, price12: 3500, price24: 5000, category: "SUV" },
  { name: "Tata Safari", img: c4, price12: 4000, price24: 6000, category: "SUV" },
  { name: "Mahindra XUV700", img: c5, price12: 5000, price24: 7500, category: "SUV" },
  { name: "Innova Crysta", img: c6, price12: 4500, price24: 7000, category: "SUV" },
  { name: "Kia Seltos", img: c7, price12: 3500, price24: 5200, category: "SUV" },
  { name: "Hyundai Creta", img: c8, price12: 3200, price24: 4800, category: "SUV" },
  { name: "MG Hector", img: c9, price12: 4200, price24: 6200, category: "SUV" },
  { name: "Toyota Hyryder", img: c10, price12: 3800, price24: 5500, category: "SUV" },
  { name: "Ertiga CNG 2025", img: c11, price12: 2200, price24: 3000, category: "Sedan" },
  { name: "Verna Sunroof", img: c12, price12: 3500, price24: 4500, category: "Sedan" },
  { name: "Baleno 2025", img: c13, price12: 1500, price24: 2000, category: "Sedan" },
  { name: "Swift 2025", img: c14, price12: 1500, price24: 2500, category: "Sedan" },
  { name: "Honda City", img: c15, price12: 3000, price24: 4200, category: "Sedan" },
  { name: "i20 Sportz", img: c16, price12: 1800, price24: 2600, category: "Sedan" },
  { name: "Honda Amaze", img: c17, price12: 2500, price24: 3500, category: "Sedan" },
  { name: "Maruti Dzire", img: c18, price12: 2200, price24: 3200, category: "Sedan" },
  { name: "Tata Altroz", img: c19, price12: 2000, price24: 3000, category: "Sedan" },
  { name: "Maruti Ciaz", img: c20, price12: 2800, price24: 4000, category: "Sedan" },
  { name: "Audi A6", img: c21, price12: 12000, price24: 18000, category: "Luxury" },
  { name: "BMW 5 Series", img: c22, price12: 13000, price24: 19000, category: "Luxury" },
  { name: "Mercedes C-Class", img: c23, price12: 14000, price24: 20000, category: "Luxury" },
  { name: "Jaguar XF", img: c24, price12: 15000, price24: 22000, category: "Luxury" },
  { name: "Audi Q7", img: c25, price12: 18000, price24: 28000, category: "Luxury" },
  { name: "BMW X5", img: c26, price12: 20000, price24: 30000, category: "Luxury" },
  { name: "Mercedes E-Class", img: c27, price12: 16000, price24: 24000, category: "Luxury" },
  { name: "BMW 7 Series", img: c28, price12: 22000, price24: 35000, category: "Luxury" },
  { name: "Audi A4", img: c29, price12: 11000, price24: 17000, category: "Luxury" },
  { name: "Volvo XC90", img: c30, price12: 25000, price24: 38000, category: "Luxury" },
  { name: "Luxury Wedding Car", img: c31, price12: 15000, price24: 25000, category: "Wedding" },
  { name: "Bride & Groom Special", img: c32, price12: 12000, price24: 20000, category: "Wedding" },
  { name: "Full Day Package", img: c33, price12: 20000, price24: 35000, category: "Wedding" },
  { name: "VIP Event Car", img: c34, price12: 8000, price24: 15000, category: "Wedding" },
  { name: "Decorated Car", img: c35, price12: 18000, price24: 28000, category: "Wedding" },
  { name: "Barat Car Package", img: c36, price12: 10000, price24: 18000, category: "Wedding" },
  { name: "Wedding SUV", img: c37, price12: 14000, price24: 22000, category: "Wedding" },
  { name: "Luxury Convoy", img: c38, price12: 30000, price24: 50000, category: "Wedding" },
  { name: "Reception Entry", img: c39, price12: 10000, price24: 18000, category: "Wedding" },
  { name: "Corporate Event", img: c40, price12: 12000, price24: 20000, category: "Wedding" },
];

const CATEGORIES = ["All", "SUV", "Sedan", "Luxury", "Wedding"];

export default function SelfDrive() {
  const [search, setSearch] = useState("");
  const [cat, setCat] = useState("All");
  const [customCar, setCustomCar] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const filtered = useMemo(() => {
    return ALL_CARS.filter(car =>
      (cat === "All" || car.category === cat) &&
      car.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, cat]);

  const whatsapp = (name) => {
    const msg = `Hello Shree Ram Car Rental.com! I want to book the ${name} for self-drive.`;
    window.open(`https://wa.me/91${PHONE}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div className="sd-wrapper">
      <Helmet>
        <title>Self Drive Cars Indore | Premium Fleet - Shree Ram Car Rental.com</title>
        <meta name="description" content="Rent premium self-drive cars in Indore with Shree Ram Car Rental.com. SUVs, Sedans, Luxury & Wedding cars. 24/7 delivery. Starting ₹1500/day." />
      </Helmet>

      {/* HERO */}
      <section className="sd-hero" style={{ backgroundImage: `url(${bg})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="reveal-text">INDORE'S MOST TRUSTED</span>
          <h1 className="main-title">Drive Your <span>Dreams</span></h1>
          <p className="sub-title">Premium Self-Drive Experience • 24/7 Delivery • Zero Hidden Costs</p>
        </div>
      </section>

      {/* SEARCH / FILTER */}
      <div className={`sd-search-navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="search-glass">
          <input 
            type="text" 
            placeholder="🔍 Search for a brand or model..." 
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="category-chips">
          {CATEGORIES.map(c => (
            <button 
              key={c} 
              className={cat === c ? "chip active" : "chip"} 
              onClick={() => setCat(c)}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* CAR GRID */}
      <section className="sd-grid-container">
        <div className="sd-grid">
          {filtered.length === 0 ? (
            <div className="no-results">
              <h2>No cars found</h2>
              <p>Try adjusting your search or category filter</p>
            </div>
          ) : (
            filtered.map((car, i) => (
              <div className="glass-card" key={i}>
                <div className="image-wrapper">
                  <img src={car.img} alt={`${car.name} - Shree Ram Car Rental.com`} loading="lazy" />
                  <div className="badge">{car.category}</div>
                </div>
                <div className="card-details">
                  <h3>{car.name}</h3>
                  <div className="pricing-grid">
                    <div className="price-box">
                      <span>12 Hours</span>
                      <strong>₹{car.price12.toLocaleString()}</strong>
                    </div>
                    <div className="price-box highlight">
                      <span>24 Hours</span>
                      <strong>₹{car.price24.toLocaleString()}</strong>
                    </div>
                  </div>
                  <button className="cta-button" onClick={() => whatsapp(car.name)}>
                    Check Availability
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </section>

      {/* CUSTOM REQUEST */}
      <section className="sd-custom-req">
        <div className="custom-glass-box">
          <h2>Specific Requirement?</h2>
          <p>If you don't find what you're looking for, we'll arrange it for you.</p>
          <div className="input-flex">
            <input 
              placeholder="Enter Car Model..." 
              value={customCar}
              onChange={(e) => setCustomCar(e.target.value)}
            />
            <button 
              onClick={() => {
                if (customCar.trim()) {
                  window.open(`https://wa.me/91${PHONE}?text=Hi, I want to arrange: ${customCar} - via Shree Ram Car Rental.com`, "_blank");
                }
              }}
              disabled={!customCar.trim()}
            >
              Request Car
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}